import { ApiService } from "./api.service";
export default class LayoutService extends ApiService {
  template = "defaultTemplate";
  relations = "?expand=header,body,files,files.file";
  namespace = "layout";
  icon = "ThreeBlocks";
  action = "action";
  favicon = "Layout";
  Width = 1000;
  DOMAIN = -28;
  name = "layout";
  singular = this.terminology.layout.singular;
  plural = this.terminology.layout.plural;
  vowel = this.terminology.layout.vowel;
  fieldMapping = ['type', 'name','description','quantity', 'rate', null,null,'markup', 'amount', 'total']
  layout = {
    header: [
      {
        type: 0,
        item: 0,
        order: 0,
        screen: 1,
        print: 1,
        label: "Title",
        title: "INVOICE",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 1,
        order: 0,
        screen: 1,
        print: 1,
        label: "Number",
        title: "Invoice #",
        box_size: "",
        section: 1,
        disabled: true,
      },
      {
        type: 0,
        item: 2,
        order: 0,
        screen: 1,
        print: 1,
        label: "Date",
        title: "Invoice Date",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 3,
        order: 0,
        screen: 1,
        print: 1,
        label: "Bill/Mail Address",
        title: "Billing Address",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 4,
        order: 0,
        screen: 1,
        print: 1,
        label: "Ship/Deliver Address",
        title: "Delivery Address",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 5,
        order: 0,
        screen: 1,
        print: 1,
        label: "P.O. Number",
        title: "P.O. Number",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 6,
        order: 0,
        screen: 1,
        print: 1,
        label: "Incoterms",
        title: "Incoterms",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 7,
        order: 0,
        screen: 1,
        print: 1,
        label: "Term Point",
        title: "Term Point",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 8,
        order: 0,
        screen: 1,
        print: 1,
        label: "Delivery Method",
        title: "Delivery Method",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 9,
        order: 0,
        screen: 1,
        print: 1,
        label: "Delivery Date",
        title: "Delivery Date",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 10,
        order: 0,
        screen: 0,
        print: 0,
        label: "Tracking Number",
        title: "Tracking Number",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 11,
        order: 0,
        screen: 1,
        print: 1,
        label: "Terms",
        title: "Terms",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 12,
        order: 0,
        screen: 1,
        print: 1,
        label: "Due Date",
        title: "Due Date",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 13,
        order: 0,
        screen: 1,
        print: 1,
        label: "Sales Rep",
        title: "Sales Rep",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 14,
        order: 0,
        screen: 0,
        print: 1,
        label: "Customer Name",
        title: "Customer Name",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 15,
        order: 0,
        screen: 0,
        print: 1,
        label: "Account Number",
        title: "Account Number",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 16,
        order: 0,
        screen: 0,
        print: 1,
        label: "Bill/Mail Customer Name",
        title: "Customer Name",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 17,
        order: 0,
        screen: 0,
        print: 1,
        label: "Telephone",
        title: "Telephone",
        box_size: "",
        section: 3,
      },
      {
        type: 0,
        item: 18,
        order: 0,
        screen: 0,
        print: 1,
        label: "Fax",
        title: "Fax",
        box_size: "",
        section: 3,
      },
      {
        type: 0,
        item: 19,
        order: 0,
        screen: 0,
        print: 1,
        label: "E-mail Address",
        title: "E-mail Address",
        box_size: "",
        section: 3,
      },
      {
        type: 0,
        item: 20,
        order: 0,
        screen: 0,
        print: 1,
        label: "Website",
        title: "Website",
        box_size: "22",
        section: 3,
      },
      {
        type: 0,
        item: 21,
        order: 0,
        screen: 0,
        print: 1,
        label: "Warehouse",
        title: "Warehouse",
        box_size: "23",
        section: 3,
      },
    ],
    body: [
      {
        type: 1,
        item: 0,
        order: 0,
        screen: 2,
        print: 2,
        label: "Line Type",
        title: "Type",
        box_size: "auto",
        section: 0,
      },
      {
        type: 1,
        item: 1,
        order: 0,
        screen: 2,
        print: 2,
        label: "Line Name",
        title: "Name",
        box_size: "170px",
        section: 0,
      },
      {
        type: 2,
        item: 5,
        order: 0,
        screen: 1,
        print: 1,
        label: "Description Item",
        title: "Description",
        box_size: null,
        section: 1,
      },
      {
        type: 2,
        item: 10,
        order: 0,
        screen: 1,
        print: 0,
        label: "Quantity",
        title: "Quantity",
        box_size: null,
        section: 1,
      },
      {
        type: 1,
        item: 2,
        order: 0,
        screen: 1,
        print: 1,
        label: "Rate",
        title: "Rate",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 3,
        order: 0,
        screen: 1,
        print: 1,
        label: "Color",
        title: "Color",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 4,
        order: 0,
        screen: 1,
        print: 1,
        label: "Classification",
        title: "Classification",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 7,
        order: 0,
        screen: 1,
        print: 0,
        label: "Line Markup",
        title: "Markup",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 8,
        order: 0,
        screen: 1,
        print: 0,
        label: "Line Subtotal",
        title: "total",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 9,
        order: 0,
        screen: 2,
        print: 2,
        label: "Line Total",
        title: "Amount",
        box_size: "auto",
        section: 2,
      },
    ],
  };

  salesReciptLayout = {
    headerInput: {
      generalInformation: [
        {
          label: "Title",
          title: "Sales Reciept",
          screen: "1",
          print: "1",
        },
        {
          label: "Number",
          title: "Sale #",
          screen: "1",
          print: "1",
          disable: true,
        },
        {
          label: "Date",
          title: "Sale Date",
          screen: "1",
          print: "1",
          disable: true,
        },
      ],

      customerInformation: [
        {
          label: "Bill/Mail Address",
          title: "Sold To",
          screen: 1,
          print: 1,
        },
        {
          label: "Ship/Deliver Address",
          title: "Delivery Address",
          screen: 1,
          print: 1,
        },
        {
          label: "P.O. Number",
          title: "P.O. Number",
          screen: 1,
          print: 1,
        },
        {
          label: "Incoterms",
          title: "Incoterms",
          screen: 1,
          print: 1,
        },
        {
          label: "Term Point",
          title: "Term Point",
          screen: 1,
          print: 1,
        },
        {
          label: "Delivery Method",
          title: "Delivery Method",
          screen: 1,
          print: 1,
        },
        {
          label: "Delivery Date",
          title: "Delivery Date",
          screen: 1,
          print: 1,
        },
      ],
      generalInfo: [
        {
          label: "Tracking Number",
          title: "Tracking Number",
          screen: 1,
          print: 1,
        },
        {
          label: "Terms",
          title: "Terms",
          screen: 1,
          print: 1,
        },
        {
          label: "Due Date",
          title: "Due Date",
          screen: 1,
          print: 1,
        },
        {
          label: "Sales Rep",
          title: "Sales Rep",
          screen: 1,
          print: 1,
        },
      ],
      customerInfo: [
        {
          label: "Customer Name	",
          title: "Customer Name	",
          screen: 0,
          print: 1,
          disable: true,
        },
        {
          label: "Account Number",
          title: "Account Number",
          screen: 0,
          print: 1,
          disable: true,
        },
        {
          label: "Bill/Mail Customer Name	",
          title: "Bill/Mail Customer Name	",
          screen: 0,
          print: 1,
          disable: true,
        },
      ],
      companyInformation: [
        {
          label: "Telephone	",
          title: "Telephone	",
          screen: 0,
          print: 1,
          disable: true,
        },
        {
          label: "Fax",
          title: "Fax",
          screen: 0,
          print: 1,
          disable: true,
        },
        {
          label: "E-mail Address",
          title: "E-mail Address",
          screen: 0,
          print: 1,
          disable: true,
        },
        {
          label: "Website",
          title: "Website",
          screen: 0,
          print: 1,
          disable: true,
        },
      ],
    },
    bodyInputs: [
      {
        item: "Line Type",
        screen: 1,
        print: 0,
        title: "Type",
        disable: true,
      },
      {
        item: "Line Name",
        screen: 1,
        print: 0,
        title: "Name",
        disable: true,
      },

      {
        item: "Line Description",
        screen: 1,
        print: 1,
        title: "Description",
        disable: false,
      },
      {
        item: "Line Quantity",
        screen: 1,
        print: 1,
        title: "Quantity",
        disable: false,
      },
      {
        item: "Line Rate",
        screen: 1,
        print: 1,
        title: "Rate",
        disable: false,
      },
      {
        item: "Line Classification",
        screen: 1,
        print: 0,
        title: "Classification",
        disable: true,
      },
      {
        item: "Line Markup",
        screen: 1,
        print: 0,
        title: "Markup",
        disable: false,
      },
      {
        item: "Line Subtotal",
        screen: 1,
        print: 0,
        title: "Subtotal",
        disable: false,
      },
      {
        item: "Line Amount",
        screen: 1,
        print: 0,
        title: "Amount",
        disable: false,
      },
      {
        item: "Line Total",
        screen: 1,
        print: 1,
        title: "Total",
        disable: true,
      },
    ],
  };

  layout = {
    header: [
      {
        type: 0,
        item: 0,
        order: 0,
        screen: 1,
        print: 1,
        label: "Title",
        title: "INVOICE",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 1,
        order: 0,
        screen: 1,
        print: 1,
        label: "Number",
        title: "Invoice #",
        box_size: "",
        section: 1,
        disabled: true,
      },
      {
        type: 0,
        item: 2,
        order: 0,
        screen: 1,
        print: 1,
        label: "Date",
        title: "Invoice Date",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 3,
        order: 0,
        screen: 1,
        print: 1,
        label: "Bill/Mail Address",
        title: "Billing Address",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 4,
        order: 0,
        screen: 1,
        print: 1,
        label: "Ship/Deliver Address",
        title: "Delivery Address",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 5,
        order: 0,
        screen: 1,
        print: 1,
        label: "P.O. Number",
        title: "P.O. Number",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 6,
        order: 0,
        screen: 1,
        print: 1,
        label: "Incoterms",
        title: "Incoterms",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 7,
        order: 0,
        screen: 1,
        print: 1,
        label: "Term Point",
        title: "Term Point",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 8,
        order: 0,
        screen: 1,
        print: 1,
        label: "Delivery Method",
        title: "Delivery Method",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 9,
        order: 0,
        screen: 1,
        print: 1,
        label: "Delivery Date",
        title: "Delivery Date",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 10,
        order: 0,
        screen: 0,
        print: 0,
        label: "Tracking Number",
        title: "Tracking Number",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 11,
        order: 0,
        screen: 1,
        print: 1,
        label: "Terms",
        title: "Terms",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 12,
        order: 0,
        screen: 1,
        print: 1,
        label: "Due Date",
        title: "Due Date",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 13,
        order: 0,
        screen: 1,
        print: 1,
        label: "Sales Rep",
        title: "Sales Rep",
        box_size: "",
        section: 1,
      },
      {
        type: 0,
        item: 14,
        order: 0,
        screen: 0,
        print: 1,
        label: "Customer Name",
        title: "Customer Name",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 15,
        order: 0,
        screen: 0,
        print: 1,
        label: "Account Number",
        title: "Account Number",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 16,
        order: 0,
        screen: 0,
        print: 1,
        label: "Bill/Mail Customer Name",
        title: "Customer Name",
        box_size: "",
        section: 2,
      },
      {
        type: 0,
        item: 17,
        order: 0,
        screen: 0,
        print: 1,
        label: "Telephone",
        title: "Telephone",
        box_size: "",
        section: 3,
      },
      {
        type: 0,
        item: 18,
        order: 0,
        screen: 0,
        print: 1,
        label: "Fax",
        title: "Fax",
        box_size: "",
        section: 3,
      },
      {
        type: 0,
        item: 19,
        order: 0,
        screen: 0,
        print: 1,
        label: "E-mail Address",
        title: "E-mail Address",
        box_size: "",
        section: 3,
      },
      {
        type: 0,
        item: 20,
        order: 0,
        screen: 0,
        print: 1,
        label: "Website",
        title: "Website",
        box_size: "22",
        section: 3,
      },
      {
        type: 0,
        item: 21,
        order: 0,
        screen: 0,
        print: 1,
        label: "Warehouse",
        title: "Warehouse",
        box_size: "23",
        section: 3,
      },
    ],
    body: [
      {
        type: 1,
        item: 0,
        order: 0,
        screen: 2,
        print: 2,
        label: "Line Type",
        title: "Type",
        box_size: "auto",
        section: 0,
      },
      {
        type: 1,
        item: 1,
        order: 0,
        screen: 2,
        print: 2,
        label: "Line Name",
        title: "Name",
        box_size: "170px",
        section: 0,
      },
      {
        type: 2,
        item: 5,
        order: 0,
        screen: 1,
        print: 1,
        label: "Description Item",
        title: "Description",
        box_size: null,
        section: 1,
      },
      {
        type: 2,
        item: 10,
        order: 0,
        screen: 1,
        print: 0,
        label: "Quantity",
        title: "Quantity",
        box_size: null,
        section: 1,
      },
      {
        type: 1,
        item: 2,
        order: 0,
        screen: 1,
        print: 1,
        label: "Rate",
        title: "Rate",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 3,
        order: 0,
        screen: 1,
        print: 1,
        label: "Color",
        title: "Color",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 4,
        order: 0,
        screen: 1,
        print: 1,
        label: "Classification",
        title: "Classification",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 7,
        order: 0,
        screen: 1,
        print: 0,
        label: "Line Markup",
        title: "Markup",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 8,
        order: 0,
        screen: 1,
        print: 0,
        label: "Line Subtotal",
        title: "total",
        box_size: "auto",
        section: 1,
      },
      {
        type: 1,
        item: 9,
        order: 0,
        screen: 2,
        print: 2,
        label: "Line Total",
        title: "Amount",
        box_size: "auto",
        section: 2,
      },
    ],
  };
  constructor() {
    super("ar-invoice-layouts");
  }
}
